<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
        <header-component 
          :headerTitle="headerText"
          :router-link="getRouterLink()"
          :router-link-text="getRouterLinkText()"
          :component-name="componentsName()"
           />
        <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
        <v-layout align-center pr-4>
            <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
            <v-layout column>
            <div>{{ snackbar.text }}</div>
            </v-layout>
        </v-layout>
        <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
            <v-icon>clear</v-icon>
        </v-btn>
        </v-snackbar>
        <v-card class="v-card-100 mt-0">
            <v-card-title class="action-style pt-4 pb-6">
                <!-- Search fields -->
                <v-row class="ma-1">
                    <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" class="mr-4"
                        style="max-width: 270px;max-height:52px" variant="outlined" color="primary" @keyup.enter="fetchApprovalRules('search')"></v-text-field>
                    <v-spacer></v-spacer>
                </v-row>
            </v-card-title>        
        </v-card>
        <v-layout column>
        <v-data-table 
            hover
            density="compact"
            :search="search"
            v-model="selected"
            show-select
            disable-pagination
            :hide-default-footer="true"
            :headers="headers"
            :items="table_data"
            :loading="loading"
            :items-per-page="pageSize"
            fixed-header
            height="100%"
            loading-text="Loading Data... Please wait" 
            class="elevation-1"
            return-object
            >
            <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
                <span v-if="header.key == 'action'">
                    <v-icon color="primary">mdi-pencil-outline</v-icon>
                </span> 
                <span v-else-if="header.key !== 'imags' && item[header.key]">
                    <span v-tooltip="item[header.key]">
                    {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                    </span>
                </span>
                <span v-else>-</span>
                </template>
            <template #bottom></template>
        </v-data-table>
    </v-layout>
    <!-- pagination display -->
     <PaginationComponent
             :pageSize="pageSize"
             :pageSizes="pageSizes"
             :totalCount="totalCount"
             :selected="selected"
             :page="page"
             :totalPages="totalPages"
             @update:pageSize="handlePageSizeChange"
             @update:page="handlePageChange"
             class="mt-2 mb-2"
          />
    </v-card>
</template>
<script setup>
import { ref, reactive, onMounted, getCurrentInstance } from 'vue';
import HeaderComponent from '../../../commoncomponents/HeaderComponent.vue';
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import { useStore } from "vuex";
import { useRouter, useRoute } from 'vue-router' 
    const store = useStore();
    const router = useRouter();
    const route = useRoute();   
    const { proxy } = getCurrentInstance();
    const headerText = ref("View Rules");
    const snackbar = reactive( {
            color: null,
            icon: null,
            mode: null,
            position: "top",
            text: null,
            timeout: 7500,
            title: null,
            visible: false
        });
    const search_tag = ref('');
    const selected = ref([]);
    const table_data = ref([]);
    const loading = ref(false);
    const headers = ref([ 
            { title: `Seq No.`, key: "rule_precedence", minWidth: "200px" },
            { title: "Rule ID", key: "rule_id", minWidth: "150px" },
            { title: "Rule Defination", key: "expression", minWidth: "150px" },
            { title: "Output Value", key: "rule_output", minWidth: "150px" },
            ]);
    const search = ref('');
    const page = ref(1);
    const pageSize = ref(defaultPageSize);
    const pageSizes = defaultPageSizes;
    const totalCount = ref(0);
    const totalPages = ref(1);

    onMounted(() => {
        fetchApprovalRules();
    })
    const fetchApprovalRules = () => {
        loading.value = true;
        selected.value = [];
        table_data.value = [];
        page.value = 1;
        totalPages.value = 1;
        
        const params = {
            page: page.value,
            per_page: pageSize.value
        }
        if(search_tag.value != '') {
            params.search = search_tag.value
        }
        proxy.$httpSecured
        .get("api/v2/rule_engine/rule_engine_configurations/get_rule_config_data?rule_type=ticket_eligibility_validation_rule", { params })
        .then(response => {
            if(response.data) {
               table_data.value = response.data.rule_configurations;
               totalPages.value = response.data.meta.total_pages;
               totalCount.value = response.data.meta.total_count;
               loading.value = false;
            }else{
                loading.value = false;
                proxy.$toast.error("No Data Found");
            }
        })
        .catch(error => {
            loading.value = false;
            proxy.$toast.error(error.response.data.error);
        })
    }
    const getRouterLink = () => {
        return { name: "CreateNewApprovalConfig" };
    }
    const componentsName = () => {
        return "View Rules";
    }

    const getRouterLinkText = () => {
        return store.state.inventoryId
    }
</script>
